import { render, staticRenderFns } from "./messageText.vue?vue&type=template&id=31293ad1&scoped=true"
import script from "./messageText.vue?vue&type=script&lang=js"
export * from "./messageText.vue?vue&type=script&lang=js"
import style0 from "./messageText.vue?vue&type=style&index=0&id=31293ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31293ad1",
  null
  
)

export default component.exports